export default class SegmentRange {
  min = 0;
  max = 0;

  constructor([min, max]: [number | null, number | null]) {
    this.min = min || -Infinity;
    this.max = max || Infinity;
  }

  isOverlapping([min, max]: [number | null, number | null]) {
    if ((min || -Infinity) < this.min) return (max || Infinity) > this.min;
    else return (min || -Infinity) < this.max;
  }
}
